//  import React, { useState } from 'react';

// const AdvancedHomeScreen = () => {
//   const [activeTab, setActiveTab] = useState('oneway');
//   const [origin, setOrigin] = useState('');
//   const [destination, setDestination] = useState('');
//   const [date, setDate] = useState('');
//   const [passengers, setPassengers] = useState(1);

//   const destinations = [
//     { id: 1, city: 'DUBAI', country: 'UAE', price: '₹18,999', img: 'https://images.unsplash.com/photo-1551632811-561732a7d4d0?w=800' },
//     { id: 2, city: 'LONDON', country: 'UK', price: '₹32,499', img: 'https://images.unsplash.com/photo-1540979388789-6cee28a1cdc9?w=800' },
//     { id: 3, city: 'TOKYO', country: 'JAPAN', price: '₹45,999', img: 'https://images.unsplash.com/photo-1553788994-4f3329bc8c48?w=800' },
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900/30 to-slate-900 overflow-hidden relative">
//       {/* Animated Background Particles */}
//       <div className="fixed inset-0 opacity-20">
//         <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-blue-500/20 rounded-full blur-3xl animate-pulse"></div>
//         <div className="absolute top-3/4 right-1/4 w-96 h-96 bg-indigo-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
//         <div className="absolute bottom-1/4 left-1/2 w-64 h-64 bg-purple-500/20 rounded-full blur-3xl animate-pulse delay-500"></div>
//       </div>

//       {/* Futuristic Navbar */}
//       <nav className="backdrop-blur-xl bg-white/10 border border-white/20 fixed top-0 left-0 right-0 z-50 px-6 py-4">
//         <div className="max-w-7xl mx-auto flex items-center justify-between">
//           <div className="text-2xl font-black bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
//             ✈️ VimanGo
//           </div>
//           <div className="hidden md:flex items-center space-x-8">
//             <a className="text-white/80 hover:text-white transition-all duration-300 font-medium">Flights</a>
//             <a className="text-white/80 hover:text-white transition-all duration-300 font-medium">Hotels</a>
//             <a className="text-white/80 hover:text-white transition-all duration-300 font-medium">Explore</a>
//           </div>
//           <button className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-8 py-3 rounded-3xl font-bold backdrop-blur-sm border border-white/20 hover:from-blue-600 hover:to-indigo-700 shadow-2xl hover:shadow-blue-500/25 transition-all duration-300 hover:scale-105">
//             Sign In
//           </button>
//         </div>
//       </nav>

//       {/* Hero Section */}
//       <section className="pt-32 pb-24 px-6 md:px-12">
//         <div className="max-w-7xl mx-auto text-center">
//           <h1 className="text-5xl md:text-7xl lg:text-8xl font-black bg-gradient-to-r from-white via-blue-300 to-purple-300 bg-clip-text text-transparent mb-8 leading-tight">
//             Fly Beyond
//             <span className="block">Boundaries</span>
//           </h1>
//           <p className="text-xl md:text-2xl text-white/80 max-w-2xl mx-auto mb-16 leading-relaxed">
//             Experience luxury air travel with AI-powered search, real-time pricing, and unmatched comfort.
//           </p>
//         </div>
//       </section>

//       {/* Smart Search Engine */}
//       <section className="px-6 md:px-12 pb-24 relative z-10">
//         <div className="max-w-6xl mx-auto">
//           <div className="backdrop-blur-3xl bg-white/10 border border-white/20 rounded-3xl p-8 md:p-12 shadow-2xl hover:shadow-3xl transition-all duration-500">
//             <div className="flex flex-col lg:flex-row gap-6 items-stretch lg:items-center">
              
//               {/* Tab Toggle */}
//               <div className="flex bg-white/10 rounded-2xl p-1">
//                 <button
//                   onClick={() => setActiveTab('oneway')}
//                   className={`flex-1 py-3 px-6 rounded-xl font-bold transition-all duration-300 ${
//                     activeTab === 'oneway'
//                       ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg'
//                       : 'text-white/70 hover:text-white'
//                   }`}
//                 >
//                   One-way
//                 </button>
//                 <button
//                   onClick={() => setActiveTab('roundtrip')}
//                   className={`flex-1 py-3 px-6 rounded-xl font-bold transition-all duration-300 ${
//                     activeTab === 'roundtrip'
//                       ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg'
//                       : 'text-white/70 hover:text-white'
//                   }`}
//                 >
//                   Round Trip
//                 </button>
//               </div>

//               {/* Search Inputs */}
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 flex-1">
//                 <div>
//                   <label className="block text-white/70 text-sm font-medium mb-2">Origin</label>
//                   <div className="relative">
//                     <input
//                       type="text"
//                       placeholder="From Delhi (DEL)"
//                       value={origin}
//                       onChange={(e) => setOrigin(e.target.value)}
//                       className="w-full bg-white/10 border border-white/20 rounded-2xl px-5 py-4 text-white placeholder-white/50 backdrop-blur-sm focus:outline-none focus:border-blue-400 transition-all duration-300"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-white/70 text-sm font-medium mb-2">Destination</label>
//                   <div className="relative">
//                     <input
//                       type="text"
//                       placeholder="To Dubai (DXB)"
//                       value={destination}
//                       onChange={(e) => setDestination(e.target.value)}
//                       className="w-full bg-white/10 border border-white/20 rounded-2xl px-5 py-4 text-white placeholder-white/50 backdrop-blur-sm focus:outline-none focus:border-blue-400 transition-all duration-300"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-white/70 text-sm font-medium mb-2">Date</label>
//                   <input
//                     type="date"
//                     value={date}
//                     onChange={(e) => setDate(e.target.value)}
//                     className="w-full bg-white/10 border border-white/20 rounded-2xl px-5 py-4 text-white backdrop-blur-sm focus:outline-none focus:border-blue-400 transition-all duration-300 cursor-pointer"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-white/70 text-sm font-medium mb-2">Passengers</label>
//                   <select
//                     value={passengers}
//                     onChange={(e) => setPassengers(Number(e.target.value))}
//                     className="w-full bg-white/10 border border-white/20 rounded-2xl px-5 py-4 text-white backdrop-blur-sm focus:outline-none focus:border-blue-400 transition-all duration-300 cursor-pointer"
//                   >
//                     <option>1 Adult</option>
//                     <option>2 Adults</option>
//                     <option>3 Adults</option>
//                     <option>Family</option>
//                   </select>
//                 </div>
//               </div>

//               {/* Search Button */}
//               <button className="bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-600 text-white px-12 py-6 rounded-3xl font-black text-xl shadow-2xl hover:shadow-blue-500/50 hover:scale-105 transition-all duration-300 animate-pulse-hover lg:col-span-1 flex items-center justify-center">
//                 <span>🔍 Search Flights</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Trust Badges */}
//       <section className="px-6 md:px-12 pb-24">
//         <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
//           {[
//             { icon: '🛡️', title: '24/7 Support', desc: 'Round the clock assistance' },
//             { icon: '🔒', title: 'Secure Payments', desc: 'Bank-level encryption' },
//             { icon: '💰', title: 'Best Price Guarantee', desc: 'Price match promise' },
//           ].map((badge, idx) => (
//             <div key={idx} className="backdrop-blur-sm bg-white/5 border border-white/10 rounded-2xl p-8 text-center hover:bg-white/10 hover:scale-105 transition-all duration-300 cursor-pointer">
//               <div className="text-4xl mb-4">{badge.icon}</div>
//               <h3 className="text-xl font-bold text-white mb-2">{badge.title}</h3>
//               <p className="text-white/60">{badge.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Curated Destinations */}
//       <section className="px-6 md:px-12 pb-24">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl md:text-5xl font-black bg-gradient-to-r from-white to-blue-300 bg-clip-text text-transparent text-center mb-20">
//             Curated Destinations
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {destinations.map((dest) => (
//               <div
//                 key={dest.id}
//                 className="group relative overflow-hidden rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-700 hover:scale-105 cursor-pointer bg-gradient-to-t from-black/50 to-transparent"
//               >
//                 <img
//                   src={dest.img}
//                   alt={dest.city}
//                   className="w-full h-96 object-cover group-hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
//                 <div className="absolute bottom-8 left-8 right-8">
//                   <h3 className="text-4xl md:text-5xl font-black text-white mb-2 drop-shadow-2xl">
//                     {dest.city}
//                   </h3>
//                   <p className="text-white/80 text-lg mb-6 drop-shadow-lg">{dest.country}</p>
//                   <div className="backdrop-blur-xl bg-white/10 border border-white/20 px-6 py-3 rounded-2xl inline-flex items-center font-bold text-white shadow-2xl group-hover:bg-white/20 transition-all duration-300">
//                     {dest.price} <span className="ml-2 text-sm opacity-75">per person</span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <style jsx>{`
//         @keyframes pulse-hover {
//           0%, 100% { box-shadow: 0 25px 50px -12px rgba(59, 130, 246, 0.5); }
//           50% { box-shadow: 0 25px 50px -12px rgba(59, 130, 246, 0.8); }
//         }
//         .animate-pulse-hover:hover {
//           animation: pulse-hover 2s infinite;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AdvancedHomeScreen;


// import React, { useState, useEffect } from 'react';

// function SchoolNoticeBoard() {
//   const [notices, setNotices] = useState([]);

//   useEffect(() => {
//   // Timestamp add karne se browser purana data nahi dikhayega
//   const url = 'https://bazaarbandhan.com/schooldata/wp-json/wp/v2/posts?_embed&v=' + Math.random();

//   fetch(url)
//     .then(response => {
//       if (!response.ok) throw new Error("Network response was not ok");
//       return response.json();
//     })
//     .then(data => {
//       console.log("Fresh Data:", data); // Check karein naya data aa raha hai ya nahi
//       setNotices(data);
//     })
//     .catch(error => console.error("Error:", error));
// }, []);
//   // useEffect(() => {
//   //   // Aapka live API link
//   //   fetch('https://bazaarbandhan.com/schooldata/wp-json/wp/v2/posts')
//   //     .then(response => response.json())
      
//   //     .then(data => {
//   //       setNotices(data);
//   //     })
//   //     .catch(error => console.error("Data fetch nahi ho raha:", error));
//   // }, []);

//   return (
//     <div style={{ padding: '20px', backgroundColor: '#f4f4f4', minHeight: '100vh' }}>
//       <h1 style={{ textAlign: 'center', color: '#333' }}>Latest School Updates</h1>
      
//       <div style={{ maxWidth: '800px', margin: '0 auto' }}>
//         {notices.map((post) => (
//           <div key={post.id} style={{ 
//             backgroundColor: '#fff', 
//             padding: '20px', 
//             marginBottom: '15px', 
//             borderRadius: '8px',
//             boxShadow: '0 2px 4px rgba(0,0,0,0.1)' 
//           }}>
//             {/* Title Render Karein */}
//             <h2 style={{ color: '#007bff' }} 
//                 dangerouslySetInnerHTML={{ __html: post.title.rendered }}></h2>
            
//             {/* Content Render Karein */}
//             <div style={{ fontSize: '16px', lineHeight: '1.6' }} 
//                  dangerouslySetInnerHTML={{ __html: post.content.rendered }}></div>
            
//             <small style={{ color: '#888' }}>
//               Posted on: {new Date(post.date).toLocaleDateString()}
//             </small>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default SchoolNoticeBoard;
 
//  import React, { useState, useEffect, useRef } from "react";
//  import Header from "./Header";
 
//  import AboutSection from "./About";
//  import GradesSection from "./GradesSection";
//  import DirectorMessage from "./DirectorMessage";
//  import ParentsTestimonial from "./ParentsTestimonial";
//  import Footer from "./Footer";
//  import InquiryForm from "./InquiryForm";
//  import Gallery from "./Gallery";
//  import { useNavigate } from 'react-router-dom';
//  import StatsCounter from "./StatsCounter";
//  import HeroSection from "./Herosection";
// export default function SchoolWebsite() {

//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     message: "",
//   });
//    const [showTopBar, setShowTopBar] = useState(true);
// const [lastScrollY, setLastScrollY] = useState(0);
//   function Counter({ value }) {
//   const [count, setCount] = useState(0);

//  useEffect(() => {
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       if (currentScrollY > lastScrollY && currentScrollY > 60) {
//         setShowTopBar(false);
//       } else {
//         setShowTopBar(true);
//       }
//       setLastScrollY(currentScrollY);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [lastScrollY]);
//   useEffect(() => {
//     let start = 0;
//     const end = value;
//     const duration = 1500;
//     const increment = end / (duration / 20);

//     const timer = setInterval(() => {
//       start += increment;
//       if (start >= end) {
//         setCount(end);
//         clearInterval(timer);
//       } else {
//         setCount(Math.floor(start));
//       }
//     }, 20);

//     return () => clearInterval(timer);
//   }, [value]);

//   return <>{count}+</>;
// }

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert("Form Submitted ✅");
//   };

//   return (
//     <div style={{ fontFamily: "Poppins, sans-serif" }}>
//      <HeroSection/>
//       <div>
//       <AboutSection/>
//       {/* baaki page content */}
//     </div>
//       {/* STATS */}
//       {/* STATS */}
// {/* <section
//   style={{
//     display: "flex",
//     justifyContent: "center",
//     gap: 30,
//     padding: 60,
//     flexWrap: "wrap",
//     background: "#fff0f5"
//   }}
// >
//   {[
//     { num: 1200, label: "Students" },
//     { num: 50, label: "Teachers" },
//     { num: 98, label: "Results" },
//   ].map((item, i) => (
//     <div
//       key={i}
//       style={{
//         background: "#fff",
//         padding: 30,
//         borderRadius: 20,
//         boxShadow: "0 10px 30px rgba(255, 77, 109, 0.2)",
//         textAlign: "center",
//         width: 170,
//         transition: "0.3s",
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.transform = "translateY(-10px)";
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.transform = "translateY(0)";
//       }}
//     >
//       <h2
//         style={{
//           background: "linear-gradient(45deg, #ff4d6d, #ff85a2)",
//           WebkitBackgroundClip: "text",
//           WebkitTextFillColor: "transparent",
//           fontSize: 32,
//         }}
//       >
//         <Counter value={item.num} />
//       </h2>

//       <p style={{ color: "#555", marginTop: 5 }}>{item.label}</p>
//     </div>
//   ))}


// </section> */}

// <StatsCounter/>
// {/* <section
//   style={{
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "stretch",
//     width: "100%",
//     background: "rgb(0, 111, 47)",
//     overflow: "hidden",
//     margin: "60px 0",
//   }}
// >
//   {[
//     { num: 1200, label: "Students" },
//     { num: 50, label: "Teachers" },
//     { num: 98, label: "Results" },
//   ].map((item, i) => (
//     <div
//       key={i}
//       style={{
//         flex: 1,
//         minWidth: 0,
//         padding: "34px 20px",
//         textAlign: "center",
//         color: "#fff",
//         position: "relative",
//         transition: "0.3s ease",
//         animation: `floatUp 2.8s ease-in-out ${i * 0.2}s infinite alternate`,
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.transform = "translateY(-6px)";
//         e.currentTarget.style.background = "rgba(255,255,255,0.08)";
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.transform = "translateY(0)";
//         e.currentTarget.style.background = "transparent";
//       }}
//     >
//       {i !== 0 && (
//         <div
//           style={{
//             position: "absolute",
//             left: 0,
//             top: "18%",
//             width: "1px",
//             height: "64%",
//             background: "rgba(255,255,255,0.7)",
//           }}
//         />
//       )}

//       <h2
//         style={{
//           fontSize: "44px",
//           margin: 0,
//           color: "#fff",
//           fontWeight: "700",
//           lineHeight: 1,
//         }}
//       >
//         <Counter value={item.num} />
//       </h2>

//       <p style={{ margin: "10px 0 0", color: "rgba(255,255,255,0.92)", fontSize: "16px", fontWeight: "500" }}>
//         {item.label}
//       </p>
//     </div>
//   ))}

//   <style>{`
//     @keyframes floatUp {
//       0% { transform: translateY(0px); }
//       100% { transform: translateY(-8px); }
//     }

//     @media (max-width: 768px) {
//       section {
//         flex-direction: column !important;
//       }
//       section > div {
//         border-bottom: 1px solid rgba(255,255,255,0.45);
//       }
//       section > div:last-child {
//         border-bottom: none;
//       }
//       section > div > div {
//         display: none;
//       }
//     }
//   `}</style>
// </section> */}

    
//       <GradesSection/>
       
//  <Gallery/>
//   <DirectorMessage/>
//   <ParentsTestimonial/>

// <InquiryForm/>
//       {/* FORM */}
//       <Footer/>
//     </div>
//   );
// }

// // Input Style
// const inputStyle = {
//   padding: 12,
//   borderRadius: 10,
//   border: "none",
//   outline: "none"
// };

// import React from "react";
// import Header from "./Header";
// import AboutSection from "./About";
// import GradesSection from "./GradesSection";
// import DirectorMessage from "./DirectorMessage";
// import ParentsTestimonial from "./ParentsTestimonial";
// import Footer from "./Footer";
// import InquiryForm from "./InquiryForm";
// import Gallery from "./Gallery";
// import StatsCounter from "./StatsCounter";
// import HeroSection from "./Herosection";

// export default function SchoolWebsite() {
//   return (
//     <div style={styles.page}>

//       {/* HEADER */}
//       <Header />

//       {/* HERO FULL WIDTH (NO GAP) */}
//       <section style={styles.fullWidth}>
//         <HeroSection />
//       </section>

//       {/* ABOUT */}
//       <section style={styles.section}>
//         <AboutSection />
//       </section>

//       {/* STATS */}
//       <section style={styles.fullWidth}>
//         <StatsCounter />
//       </section>

//       {/* GRADES */}
//       <section style={styles.section}>
//         <GradesSection />
//       </section>

//       {/* GALLERY */}
//       <section style={styles.section}>
//         <Gallery />
//       </section>

//       {/* DIRECTOR */}
//       <section style={styles.section}>
//         <DirectorMessage />
//       </section>

//       {/* TESTIMONIAL */}
//       <section style={styles.section}>
//         <ParentsTestimonial />
//       </section>

//       {/* FORM */}
//       <section style={styles.section}>
//         <InquiryForm />
//       </section>

//       {/* FOOTER */}
//       <Footer />
//     </div>
//   );
// }
import React, { Suspense, lazy } from "react";

import Header from "./Header";
import Footer from "./Footer";

// 👇 Lazy imports

const HeroSection = lazy(() => import("./Herosection"));
const AboutSection = lazy(() => import("./About"));
const StatsCounter = lazy(() => import("./StatsCounter"));
const GradesSection = lazy(() => import("./GradesSection"));
const Gallery = lazy(() => import("./Gallery"));
const DirectorMessage = lazy(() => import("./DirectorMessage"));
const ParentsTestimonial = lazy(() => import("./ParentsTestimonial"));
const InquiryForm = lazy(() => import("./InquiryForm"));

export default function SchoolWebsite() {
  return (
    <div style={styles.page}>
      <Header />

      {/* 👇 Suspense wrapper (IMPORTANT) */}
      <Suspense fallback={<div style={styles.loader}>Loading...</div>}>

        <section style={styles.fullWidth}>
          <HeroSection />
        </section>

        <section style={styles.section}>
          <AboutSection />
        </section>

        <section style={styles.fullWidth}>
          <StatsCounter />
        </section>

        <section style={styles.section}>
          <GradesSection />
        </section>

        <section style={styles.section}>
          <Gallery />
        </section>

        <section style={styles.section}>
          <DirectorMessage />
        </section>

        <section style={styles.section}>
          <ParentsTestimonial />
        </section>

        <section style={styles.section}>
          <InquiryForm />
          {/* <Footer/> */}
        </section>

      </Suspense>
 
    </div>
  );
}
/* ================= STYLES ================= */

const styles = {
//   page: {
//     fontFamily: "Poppins, sans-serif",
//     margin: 0,
//     padding: 0,
//     overflowX: "hidden",
//   },
//   loader: {
//   textAlign: "center",
//   padding: "50px",
//   fontSize: "18px",
//   color: "rgb(0,111,47)",
// },

//   // FULL WIDTH (NO GAP)
//   fullWidth: {
//     width: "100%",
//     margin: 0,
//     padding: 0,
//   },

//   // NORMAL CONTENT
//   section: {
//     width: "100%",
//     margin: 0,
//     padding: "40px 20px",
//     boxSizing: "border-box",
//   },
};